import React from 'react';

const Section = ({ children, ...props }) => (
  <div {...props} className="row white-block" style={{ marginTop: '25px', ...props.style }}>
    {children}
  </div>
);

export default Section;
